import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uploadedFiles: [],
  lastDoc: null,
  hasMore: true,
  newlyCreatedFiles: [], // Track files that need sharing prompts
};

export const uploadedSlice = createSlice({
  name: "uploadedSlice",
  initialState,
  reducers: {
    setUploadedFiles: (state, action) => {
      state.uploadedFiles = action.payload;
    },
    appendUploadedFiles: (state, action) => {
      // Filter out any files that already exist (prevent duplicates)
      const existingIds = new Set(state.uploadedFiles.map(f => f.id));
      const newFiles = action.payload.filter(f => !existingIds.has(f.id));
      state.uploadedFiles = [...state.uploadedFiles, ...newFiles];
    },
    setLastDoc: (state, action) => {
      state.lastDoc = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    addNewlyUploadedFile: (state, action) => {
      console.log("🔥 REDUX: addNewlyUploadedFile called with:", action.payload);
      console.log("🔥 REDUX: File type being added:", action.payload.type);
      console.log("🔥 REDUX: Current newlyCreatedFiles before:", state.newlyCreatedFiles);
      
      // Check if file with same ID already exists (prevent duplicates)
      const existingIndex = state.uploadedFiles.findIndex(f => f.id === action.payload.id);
      if (existingIndex === -1) {
        state.uploadedFiles.unshift(action.payload);
        console.log("🔥 REDUX: File added to uploadedFiles");
      } else {
        console.log("🔥 REDUX: File already exists in uploadedFiles, skipping duplicate");
      }
      
      // Also add to newly created files for sharing prompt
      if (!state.newlyCreatedFiles.includes(action.payload.id)) {
        state.newlyCreatedFiles.push(action.payload.id);
        console.log("🔥 REDUX: Added file ID to newlyCreatedFiles:", action.payload.id);
      } else {
        console.log("🔥 REDUX: File ID already in newlyCreatedFiles:", action.payload.id);
      }
      
      console.log("🔥 REDUX: newlyCreatedFiles after:", state.newlyCreatedFiles);
    },
    updateUploadedFileInRedux: (state, action) => {
      const { url, filePath, id } = action.payload;
      const fileToUpdate = state.uploadedFiles.find(
        (file) => file.filePath === filePath || file.id === id
      );
      if (fileToUpdate) {
        fileToUpdate.url = url;
        fileToUpdate.type = "uploaded";
      }
    },
    deleteUploadedFileInRedux: (state, action) => {
      state.uploadedFiles = state.uploadedFiles.filter(
        (file) => file.id !== action.payload.id
      );
      // Also remove from newly created files
      state.newlyCreatedFiles = state.newlyCreatedFiles.filter(id => id !== action.payload.id);
    },
    markFileAsPromptedForSharing: (state, action) => {
      const fileId = action.payload;
      console.log("🔥 REDUX UPLOADED: Marking file as prompted:", fileId);
      console.log("🔥 REDUX UPLOADED: newlyCreatedFiles before:", state.newlyCreatedFiles);
      state.newlyCreatedFiles = state.newlyCreatedFiles.filter(id => id !== fileId);
      console.log("🔥 REDUX UPLOADED: newlyCreatedFiles after:", state.newlyCreatedFiles);
    },
    updateFilePrivacyInRedux: (state, action) => {
      const { id, isPublic } = action.payload;
      const fileToUpdate = state.uploadedFiles.find((file) => file.id === id);
      if (fileToUpdate) {
        fileToUpdate.isPublic = isPublic;
      }
    },
  },
});

export const {
  setUploadedFiles,
  appendUploadedFiles,
  setLastDoc,
  setHasMore,
  addNewlyUploadedFile,
  updateUploadedFileInRedux,
  deleteUploadedFileInRedux,
  markFileAsPromptedForSharing,
  updateFilePrivacyInRedux,
} = uploadedSlice.actions;
export default uploadedSlice.reducer;
